const isNewContext = (oldCtx, newCtx) => oldCtx !== newCtx;

export {isNewContext};
